import { render, staticRenderFns } from "./CmInputTypeRadio.vue?vue&type=template&id=2bc3473f&"
import script from "./CmInputTypeRadio.vue?vue&type=script&lang=js&"
export * from "./CmInputTypeRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports